import { useWorkspaceAsset } from '@gripp/shared-logic';
import {
  EditRoutineModal,
  LoadingIndicator,
} from '@gripp/shared-ui';
import React from 'react';

export const AssetRoutineRearrangeColumn = ({
  assetId,
  requestRoutineVisible,
  onRequestRoutineClose,
}: {
  assetId: string;
  requestRoutineVisible?: boolean;
  onRequestRoutineClose?: () => void;
}) => {
  const { workspaceAsset, isLoading } = useWorkspaceAsset(assetId);

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (!workspaceAsset) {
    return null;
  }
  
  return (
    <EditRoutineModal
      workspaceAsset={workspaceAsset}
      editRoutineModalVisible={!!workspaceAsset}
      onClose={() => {}}
      isWeb
      requestRoutineVisible={requestRoutineVisible}
      onRequestRoutineClose={onRequestRoutineClose}
    />
  );
};
